import React from "react";

const OrderStatus = ({ status }) => {
  const data = {
    // Order
    new: { className: "blue", description: "New" },
    available: { className: "green", description: "Available" },
    pending_payment: { className: "blue", description: "Pending Payment" },
    pending_confirmation: { className: "blue", description: "Pending Confirmation" },
    created: { className: "red", description: "Awaiting Payment" },
    created_deposit: { className: "red", description: "Deposit" },
    cancelled: { className: "grey", description: "Canceled" },
    paid: { className: "blue", description: "Paid" },
    deposit_paid: { className: "blue", description: "Deposit" },
    dispatched: { className: "green", description: "Dispatched" },
    delivered: { className: "green", description: "Delivered" },
    refund_requested: { className: "grey", description: "Refund Requested" },
    refunded: { className: "grey", description: "Refunded" },

    // Client Requests specific
    in_progress: { className: "orange", description: "Send Proposal" },
    negotiation: { className: "orange", description: "Negotiation" },
    follow_up: { className: "orange", description: "Follow Up" },
    deposited: { className: "green", description: "Deposited" },
    done: { className: "green", description: "Done" },
    canceled: { className: "grey", description: "Canceled" },
    listing_creation: { className: "orange", description: "Listing Creation" },
  }[status];

  return (
    <div className={`order-status ${data?.className}`}>{data?.description}</div>
  );
};

export default OrderStatus;
